type TextNode = {
  value: string;
  marks?: { type: "bold" | "underline" | "italic" }[];
};

type RichTextContent = {
  content: TextNode[];
};

export type RichTextDocument = {
  content: RichTextContent[];
};

export const formatDate = (val: string | number | Date): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  return new Date(val).toLocaleString("default", options);
};

export const getFormattedTextFromNode = (node: TextNode): string => {
  const mark = node?.marks?.[0]?.type;
  const value = node?.value || "";

  switch (mark) {
    case "bold":
      return `<span class='font-grilliBook font-bold'>${value}</span>`;
    case "underline":
      return `<span class='underline'>${value}</span>`;
    case "italic":
      return `<em>${value}</em>`;
    default:
      return value;
  }
};

export const getFormattedTextFromNodeDinamo = (node: TextNode): string => {
  const mark = node?.marks?.[0]?.type;
  const value = node?.value || "";

  switch (mark) {
    case "bold":
      return `<span class='font-dinamoBold'>${value}</span>`;
    case "underline":
      return `<span class='underline'>${value}</span>`;
    case "italic":
      return `<em>${value}</em>`;
    default:
      return value;
  }
};

export const renderRichText = (nodes: string | RichTextDocument | null | undefined): string => {
  let HTML = "";
  if (!nodes) return HTML;

  const RAW: RichTextDocument = typeof nodes === "string" ? JSON.parse(nodes) : nodes;
  const NODES = RAW?.content?.[0]?.content;

  if (Array.isArray(NODES)) {
    NODES.forEach((node) => {
      HTML += getFormattedTextFromNode(node);
    });
  }

  return HTML;
};

export const renderRichTextDinamo = (
  nodes: string | RichTextDocument | null | undefined
): string => {
  let HTML = "";
  if (!nodes) return HTML;

  const RAW: RichTextDocument = typeof nodes === "string" ? JSON.parse(nodes) : nodes;
  const NODES = RAW?.content?.[0]?.content;

  if (Array.isArray(NODES)) {
    NODES.forEach((node) => {
      HTML += getFormattedTextFromNodeDinamo(node);
    });
  }

  return HTML;
};
